import { Box, Divider, Typography } from '@mui/material';
import { pdfContainerSx, pdfKeywordTrackingSx } from './PdfSxs';
import { pdfKeywordTrackingTexts } from './PdfTexts';
import { KeywordTrackingResultCss } from 'src/content/keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { removeNegativeSign } from '../config/FunctionHelperPartTwo';
import { PdfKeywordTrackingTable } from './PdfKeywordTrackingTable';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { parseAsLocalDate, timeConverter } from '../config/FunctionHelper';

export const PdfKeywordTracking = ({
  isPdfBuilder,
  reportMetaData
}: {
  isPdfBuilder?: boolean;
  reportMetaData?: any;
}) => {
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  const timeline = (pdfReportData as any)?.config?.timeline;

  let keywordTrackingCardsDataRedux =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordTrackingCardsDataRedux
    ) ?? null;

  if (pdfReportData?.keywordTracking) {
    keywordTrackingCardsDataRedux =
      pdfReportData.keywordTracking.avgCalculationDetails;
  }
  let compareAvgCalculationDetails =
    useSelector(
      (state: RootState) => state.keywordResearch.compareAvgCalculationDetails
    ) ?? null;

  if (pdfReportData?.keywordTracking?.compareAvgCalculationDetails) {
    compareAvgCalculationDetails =
      pdfReportData.keywordTracking.compareAvgCalculationDetails;
  }
  let userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const getKeywordScoreJSX = (comparisonScore) => {
    if (Math.sign(comparisonScore) === 1) {
      return (
        <div className="flex items-center gap-1">
          <img
            src={`/static/images/icons/${'green-up-arrow'}.svg`}
            alt="icon"
          />
          <p
            style={{
              ...pdfKeywordTrackingSx?.positionChangesSx,
              color: '#1A927B'
            }}
          >
            {removeNegativeSign(comparisonScore)}
          </p>
        </div>
      );
    } else if (Math.sign(comparisonScore) === -1) {
      return (
        <div className="flex items-center gap-1">
          <img
            src={`/static/images/icons/${'red-down-arrow'}.svg`}
            alt="icon"
          />
          <p
            style={{
              ...pdfKeywordTrackingSx?.positionChangesSx,
              color: '#D92D20'
            }}
          >
            {removeNegativeSign(comparisonScore)}
          </p>
        </div>
      );
    }
  };
  const positionSummary = keywordTrackingCardsDataRedux?.positionSummary || {};
  const positionChangesSummary =
    compareAvgCalculationDetails?.positionSummary || {};
  const leftItems = ['1-3', '4-10', '11-20', '21+'];
  // Check if positionSummary is a valid object and not empty
  const expectedKeys = [
    'position1To3',
    'position4To10',
    'position11To20',
    'position21Plus'
  ];

  const rightItems = (() => {
    if (!positionSummary || typeof positionSummary !== 'object') {
      console.error('Invalid positionSummary: Expected an object');
      return [0, 0, 0, 0]; // Default values if positionSummary is invalid
    }

    return expectedKeys?.map((key) => positionSummary?.[key] ?? 0);
  })();
  const rightChangedItems = (() => {
    if (!positionChangesSummary || typeof positionChangesSummary !== 'object') {
      console.error('Invalid positionChangesSummary: Expected an object');
      return [0, 0, 0, 0]; // Default values if positionChangesSummary is invalid
    }

    return expectedKeys?.map((key) => positionChangesSummary?.[key] ?? 0);
  })();
  return (
    <>
      <Box
        sx={{
          ...pdfContainerSx?.pdfCardsSx,
          //maxWidth: { xs: '1337px' }
          width: 'Fixed (1,140px)',
          minHeight: '100px',
          padding: '24px'
        }}
      >
        <div style={pdfKeywordTrackingSx?.mainDiv}>
          <p style={pdfKeywordTrackingSx?.keywordTracking}>
            {pdfKeywordTrackingTexts?.keywordTracking}
          </p>
          <p style={pdfKeywordTrackingSx?.dateSx}>
            {isPdfBuilder && timeline
              ? `${
                  timeConverter(
                    parseAsLocalDate((timeline.periodStartDate || 0) * 1000).getTime(),
                    userDetails?.date_format ||
                      reportMetaData?.dateFormat ||
                      'DD/MM/YYYY',
                    true
                  ) || '-'
                } - ${
                  timeConverter(
                    parseAsLocalDate((timeline.periodEndDate || 0) * 1000).getTime(),
                    userDetails?.date_format ||
                      reportMetaData?.dateFormat ||
                      'DD/MM/YYYY',
                    true
                  ) || '-'
                }`
              : `${
                  timeConverter(
                    parseAsLocalDate(keywordTrackingCardsDataRedux?.firstTrackingDate).getTime(),
                    userDetails?.date_format ||
                      reportMetaData?.dateFormat ||
                      'DD/MM/YYYY',
                    true
                  ) || '-'
                } - ${
                  timeConverter(
                    parseAsLocalDate(keywordTrackingCardsDataRedux?.lastUpdated).getTime(),
                    userDetails?.date_format ||
                      reportMetaData?.dateFormat ||
                      'DD/MM/YYYY',
                    true
                  ) || '-'
                }`}
          </p>
        </div>
        <div style={pdfKeywordTrackingSx?.mainCardBox}>
          <div
            style={{
              ...pdfKeywordTrackingSx?.cardBoxOne,
              ...pdfKeywordTrackingSx?.cardBox,
              width: '40%',
              alignSelf: 'stretch'
            }}
          >
            <div style={{ width: '100%' }}>
              <p
                style={{
                  ...pdfKeywordTrackingSx?.cardTitle,
                  lineHeight: '27px'
                }}
              >
                {pdfKeywordTrackingTexts?.avgPosition}
              </p>
              <div style={pdfKeywordTrackingSx?.cardValueBox}>
                <p style={pdfKeywordTrackingSx?.cardValueText}>
                  {keywordTrackingCardsDataRedux?.avgPosition || '-'}
                </p>
                {compareAvgCalculationDetails?.avgPosition &&
                  Number(compareAvgCalculationDetails?.avgPosition || 0) !==
                    0 && (
                    <div style={pdfKeywordTrackingSx?.iconBox}>
                      {parseFloat(
                        compareAvgCalculationDetails?.avgPosition || 0
                      ) < 0 ? (
                        <>
                          <div style={pdfKeywordTrackingSx?.iconStyle}>
                            <img
                              src="/static/images/icons/red_down.svg"
                              alt="icon"
                              style={{ marginTop: '5px' }}
                            />
                          </div>
                          <p
                            style={{
                              ...pdfKeywordTrackingSx?.cardChangeValue,
                              color: '#F94144'
                            }}
                          >
                            {parseFloat(
                              compareAvgCalculationDetails?.avgPosition
                            )}
                            %
                          </p>
                        </>
                      ) : compareAvgCalculationDetails?.avgPosition ? (
                        <>
                          <div style={pdfKeywordTrackingSx?.iconStyle}>
                            <img
                              src="/static/images/icons/green_up.svg"
                              alt="icon"
                              style={{ marginTop: '5px' }}
                            />
                          </div>
                          <p
                            style={{
                              ...pdfKeywordTrackingSx?.cardChangeValue,
                              color: '#1A927B'
                            }}
                          >
                            {parseFloat(
                              compareAvgCalculationDetails?.avgPosition
                            )}
                            %
                          </p>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
              </div>
            </div>
            <div>
              <Divider
                sx={pdfContainerSx?.dividerGraphSx}
                orientation="vertical"
              />
            </div>
            <div style={{ width: '100%' }}>
              <p
                style={{
                  ...pdfKeywordTrackingSx?.cardTitle,
                  lineHeight: '27px'
                }}
              >
                {pdfKeywordTrackingTexts?.traffic}
              </p>
              <div style={pdfKeywordTrackingSx?.cardValueBox}>
                <p style={pdfKeywordTrackingSx?.cardValueText}>
                  {keywordTrackingCardsDataRedux?.avgEstimatedTraffic || '-'}
                </p>
                {compareAvgCalculationDetails?.avgEstimatedTraffic &&
                  Number(
                    compareAvgCalculationDetails?.avgEstimatedTraffic || 0
                  ) !== 0 && (
                    <div style={pdfKeywordTrackingSx?.iconBox}>
                      {parseFloat(
                        compareAvgCalculationDetails?.avgEstimatedTraffic || 0
                      ) < 0 ? (
                        <>
                          <div style={pdfKeywordTrackingSx?.iconStyle}>
                            <img
                              src="/static/images/icons/red_down.svg"
                              alt="icon"
                              style={{ marginTop: '5px' }}
                            />
                          </div>
                          <p
                            style={{
                              ...pdfKeywordTrackingSx?.cardChangeValue,
                              color: '#F94144'
                            }}
                          >
                            {parseFloat(
                              compareAvgCalculationDetails?.avgEstimatedTraffic
                            )}
                            %
                          </p>
                        </>
                      ) : compareAvgCalculationDetails?.avgEstimatedTraffic ? (
                        <>
                          <div style={pdfKeywordTrackingSx?.iconStyle}>
                            <img
                              src="/static/images/icons/green_up.svg"
                              alt="icon"
                              style={{ marginTop: '5px' }}
                            />
                          </div>
                          <p
                            style={{
                              ...pdfKeywordTrackingSx?.cardChangeValue,
                              color: '#1A927B'
                            }}
                          >
                            {parseFloat(
                              compareAvgCalculationDetails?.avgEstimatedTraffic
                            )}
                            %
                          </p>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div
            style={{
              ...pdfKeywordTrackingSx?.cardBoxOne,
              // ...pdfKeywordTrackingSx?.positionMainBox,
              width: '60%'
              // minHeight: '100px',
              // maxHeight: '100px'
            }}
          >
            <div>
              <p
                style={{
                  ...pdfKeywordTrackingSx?.cardTitle,
                  lineHeight: '27px'
                }}
              >
                {pdfKeywordTrackingTexts?.positions}
              </p>
            </div>
            <div style={{ ...pdfKeywordTrackingSx?.positionMainBox }}>
              <div>
                <div style={pdfKeywordTrackingSx?.cardValueBox}>
                  <p style={pdfKeywordTrackingSx?.cardValueText}>
                    {keywordTrackingCardsDataRedux?.totalKeywords || '-'}
                  </p>
                  <Box sx={pdfKeywordTrackingSx?.positionChangesBox}>
                    {' '}
                    {getKeywordScoreJSX(
                      compareAvgCalculationDetails?.upPosition
                    )}
                    {getKeywordScoreJSX(
                      `-${compareAvgCalculationDetails?.downPosition}`
                    )}
                  </Box>
                </div>
              </div>
              <div style={pdfKeywordTrackingSx?.listMainBox}>
                <div>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="baseline"
                    gap="30px"
                  >
                    <Box
                      sx={{
                        ...pdfKeywordTrackingSx?.listBoxSx
                      }}
                    >
                      {leftItems?.slice(0, 2)?.map((item, index) => (
                        <Box
                          key={index}
                          sx={KeywordTrackingResultCss?.listItemSubBox}
                        >
                          <Typography
                            sx={KeywordTrackingResultCss?.leftListTextSx}
                            key={index}
                          >
                            {item}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        ...KeywordTrackingResultCss?.positionListBox
                      }}
                    >
                      <Box
                        sx={{
                          ...pdfKeywordTrackingSx?.listBoxSx
                        }}
                      >
                        {rightItems?.slice(0, 2)?.map((item, index) => (
                          <Typography
                            sx={KeywordTrackingResultCss?.rightListTextSx}
                            key={index}
                          >
                            {item}
                          </Typography>
                        ))}
                      </Box>
                      <Box
                        sx={{
                          ...pdfKeywordTrackingSx?.listBoxSx
                        }}
                      >
                        {rightChangedItems?.slice(0, 2)?.map((item, index) => (
                          <Typography
                            key={index}
                            sx={{
                              ...KeywordTrackingResultCss?.rightListChangedTextSx,
                              color:
                                item < 0
                                  ? '#D92D20'
                                  : item > 0
                                  ? '#1A927B'
                                  : 'transparent',
                              //marginTop: '4px',
                              minHeight: '20px' // ensures spacing even when blank
                            }}
                          >
                            {item === 0 ? '' : item > 0 ? `+${item}` : item}
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </div>
                <div>
                  <Divider
                    sx={pdfContainerSx?.dividerGraphSx}
                    orientation="vertical"
                  />
                </div>
                <div>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="baseline"
                    gap="30px"
                  >
                    <Box
                      sx={{
                        ...pdfKeywordTrackingSx?.listBoxSx
                      }}
                    >
                      {leftItems?.slice(2)?.map((item, index) => (
                        <Box
                          key={index}
                          sx={KeywordTrackingResultCss?.listItemSubBox}
                        >
                          <Typography
                            sx={KeywordTrackingResultCss?.leftListTextSx}
                            key={index}
                          >
                            {item}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        ...KeywordTrackingResultCss?.positionListBox
                      }}
                    >
                      <Box
                        sx={{
                          ...pdfKeywordTrackingSx?.listBoxSx
                        }}
                      >
                        {rightItems?.slice(2)?.map((item, index) => (
                          <Typography
                            sx={KeywordTrackingResultCss?.rightListTextSx}
                            key={index}
                          >
                            {item}
                          </Typography>
                        ))}
                      </Box>
                      <Box
                        sx={{
                          ...pdfKeywordTrackingSx?.listBoxSx
                        }}
                      >
                        {rightChangedItems?.slice(2)?.map((item, index) => (
                          <Typography
                            key={index}
                            sx={{
                              ...KeywordTrackingResultCss?.rightListChangedTextSx,
                              color:
                                item < 0
                                  ? '#D92D20'
                                  : item > 0
                                  ? '#1A927B'
                                  : 'transparent',
                              //marginTop: '4px',
                              minHeight: '20px' // ensures spacing even when blank
                            }}
                          >
                            {item === 0 ? '' : item > 0 ? `+${item}` : item}
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PdfKeywordTrackingTable />
      </Box>
    </>
  );
};
